const constants = {
  // The hight of listbox 6 loading items
  SEARCHABLE_LISTBOX_HEIGHT: '312px',
};

export default constants;
